import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import PartnerMarquee from "@/pages/home/components/PartnerMarquee";
import About from "@/pages/home/components/About";
import Advantage from "@/pages/home/components/Advantage";
import Farms from "@/pages/home/components/Farms";
import HowItWorks from "@/pages/home/components/HowItWorks";
import Stories from "@/pages/home/components/Stories";
import Footer from "@/pages/home/components/Footer";
import CookieConsent from "@/pages/home/components/CookieConsent";

export default function Home() {
  return (
    <main className="w-full bg-background-50 text-foreground-950">
      <Navbar />
      <Hero />
      <PartnerMarquee />
      <About />
      <Advantage />
      <Farms />
      <HowItWorks />
      <Stories />
      <Footer />
      <CookieConsent />
    </main>
  );
}